/* eslint react-hooks/rules-of-hooks: "off" */
import EnumBase from './Base';

export default function countriesEnum(){
  return new EnumBase([
    {
      id: 4,
      lang: 'PS',
      name: 'Afeganistão',
      nationality: 'Afegão'
    },
    {
      id: 710,
      lang: 'EN',
      name: 'África do Sul',
      nationality: 'África do Sul'
    },
    {
      id: 8,
      lang: 'SQ',
      name: 'Albânia',
      nationality: 'Albanês'
    },
    {
      id: 20,
      lang: 'CA',
      name: 'Andorra',
      nationality: 'Andorran'
    },
    {
      id: 24,
      lang: 'PT',
      name: 'Angola',
      nationality: 'Angolano'
    },
    {
      id: 682,
      lang: 'AR',
      name: 'Arábia Saudita',
      nationality: 'Arábia Saudita'
    },
    {
      id: 32,
      lang: 'ES',
      name: 'Argentina',
      nationality: 'Argentino'
    },
    {
      id: 12,
      lang: 'ES',
      name: 'Argélia',
      nationality: 'Argelino'
    },
    {
      id: 51,
      lang: 'RU',
      name: 'Armênia',
      nationality: 'Armênio'
    },
    {
      id: 16,
      lang: 'EN',
      name: 'Samoa Americana',
      nationality: 'Samoana Americana'
    },
    {
      id: 36,
      lang: 'EN',
      name: 'Austrália',
      nationality: 'Australiano'
    },
    {
      id: 40,
      lang: 'DE',
      name: 'Austria',
      nationality: 'Austríaco'
    },
    {
      id: 31,
      lang: 'RU',
      name: 'Azerbaijão',
      nationality: 'Azerbaijão, Azeri'
    },
    {
      id: 56,
      lang: 'FR',
      name: 'Bélgica',
      nationality: 'Belga'
    },
    {
      id: 204,
      lang: 'EN',
      name: 'Benin',
      nationality: 'Beninese, Beninois'
    },
    {
      id: 60,
      lang: 'EN',
      name: 'Bermudas',
      nationality: 'Bermudian, Bermudan'
    },
    {
      id: 50,
      lang: 'BN',
      name: 'Bangladesh',
      nationality: 'Bangladesh'
    },
    {
      id: 44,
      lang: 'EN',
      name: 'Bahamas',
      nationality: 'Bahamense'
    },
    {
      id: 84,
      lang: 'EN',
      name: 'Belize',
      nationality: 'Belizean'
    },
    {
      id: 72,
      lang: 'EN',
      name: 'Botsuana',
      nationality: 'Motswana, Botswanan'
    },
    {
      id: 76,
      lang: 'PT',
      name: 'Brasil',
      nationality: 'Brasileiro'
    },
    {
      id: 52,
      lang: 'EN',
      name: 'Barbados',
      nationality: 'Barbadian'
    },
    {
      id: 100,
      lang: 'BG',
      name: 'Bulgária',
      nationality: 'Búlgaro'
    },
    {
      id: 108,
      lang: 'FR',
      name: 'Burundi',
      nationality: 'Burundian'
    },
    {
      id: 64,
      lang: 'DZ',
      name: 'Butão',
      nationality: 'Butão'
    },
    {
      id: 120,
      lang: 'EN',
      name: 'Camarões',
      nationality: 'Camaronês'
    },
    {
      id: 124,
      lang: 'EN',
      name: 'Canadá',
      nationality: 'Canadense'
    },
    {
      id: 634,
      lang: 'AR',
      name: 'Catar',
      nationality: 'Catar'
    },
    {
      id: 398,
      lang: 'RU',
      name: 'Cazaquistão',
      nationality: 'Kazakhstani, Kazakh'
    },
    {
      id: 116,
      lang: 'KM',
      name: 'Camboja',
      nationality: 'Cambojano'
    },
    {
      id: 132,
      lang: 'PT',
      name: 'Cabo Verde',
      nationality: 'Cabo-verdiano'
    },
    {
      id: 148,
      lang: 'FR',
      name: 'Chade',
      nationality: 'Chadiano'
    },
    {
      id: 152,
      lang: 'ES',
      name: 'Chile',
      nationality: 'Chileno'
    },
    {
      id: 156,
      lang: 'ZH',
      name: 'China',
      nationality: 'Chinês'
    },
    {
      id: 196,
      lang: 'EL',
      name: 'Chipre',
      nationality: 'Cipriota'
    },
    {
      id: 702,
      lang: 'EN',
      name: 'Cingapura',
      nationality: 'Singapura'
    },
    {
      id: 384,
      lang: 'FR',
      name: 'Costa do Marfim',
      nationality: 'Marfinense'
    },
    {
      id: 184,
      lang: 'EN',
      name: 'Ilhas Cook',
      nationality: 'Ilha Cook'
    },
    {
      id: 170,
      lang: 'EN',
      name: 'Colômbia',
      nationality: 'Colombiano'
    },
    {
      id: 174,
      lang: 'EN',
      name: 'Comores',
      nationality: 'Comoran, Comorian'
    },
    {
      id: 188,
      lang: 'ES',
      name: 'Costa Rica',
      nationality: 'Costa Riquenho'
    },
    {
      id: 191,
      lang: 'EN',
      name: 'Croácia',
      nationality: 'Croata'
    },
    {
      id: 192,
      lang: 'ES',
      name: 'Cuba',
      nationality: 'Cubano'
    },
    {
      id: 136,
      lang: 'EN',
      name: 'Ilhas Cayman',
      nationality: 'Caymaniano'
    },
    {
      id: 208,
      lang: 'DA',
      name: 'Dinamarca',
      nationality: 'Dinamarquês'
    },
    {
      id: 262,
      lang: 'EN',
      name: 'Djibuti',
      nationality: 'Djibuti'
    },
    {
      id: 214,
      lang: 'ES',
      name: 'República Dominicana',
      nationality: 'Dominicana'
    },
    {
      id: 212,
      lang: 'EN',
      name: 'Dominica',
      nationality: 'Dominicana'
    },
    {
      id: 818,
      lang: 'AR',
      name: 'Egito',
      nationality: 'Egípcio'
    },
    {
      id: 222,
      lang: 'ES',
      name: 'El Salvador',
      nationality: 'Salvadorenho'
    },
    {
      id: 218,
      lang: 'ES',
      name: 'Equador',
      nationality: 'Equatoriano'
    },
    {
      id: 724,
      lang: 'ES',
      name: 'Espanha',
      nationality: 'Espanhol'
    },
    {
      id: 233,
      lang: 'RU',
      name: 'Estônia',
      nationality: 'Estoniano'
    },
    {
      id: 231,
      lang: 'AM',
      name: 'Etiópia',
      nationality: 'Etíope'
    },
    {
      id: 840,
      lang: 'EN',
      name: 'Estados Unidos da America',
      nationality: 'Americano (EUA)'
    },
    {
      id: 608,
      lang: 'FL',
      name: 'Filipinas',
      nationality: 'Filipino, Filipino'
    },
    {
      id: 246,
      lang: 'EN',
      name: 'Finlândia',
      nationality: 'Finlandês'
    },
    {
      id: 242,
      lang: 'EN',
      name: 'Fiji',
      nationality: 'Fijiano'
    },
    {
      id: 250,
      lang: 'FR',
      name: 'França',
      nationality: 'Francês'
    },
    {
      id: 266,
      lang: 'FR',
      name: 'Gabão',
      nationality: 'Gabão'
    },
    {
      id: 270,
      lang: 'EN',
      name: 'Gâmbia',
      nationality: 'Gâmbia'
    },
    {
      id: 288,
      lang: 'EN',
      name: 'Gana',
      nationality: 'Ganês'
    },
    {
      id: 312,
      lang: 'FR',
      name: 'Guadalupe',
      nationality: 'Guadalupe'
    },
    {
      id: 268,
      lang: 'RU',
      name: 'Geórgia',
      nationality: 'Georgiano'
    },
    {
      id: 254,
      lang: 'FR',
      name: 'Guiana Francesa',
      nationality: 'Guianês Francês'
    },
    {
      id: 292,
      lang: 'EN',
      name: 'Gibraltar',
      nationality: 'Gibraltar'
    },
    {
      id: 324,
      lang: 'ES',
      name: 'Guiné',
      nationality: 'Guineense'
    },
    {
      id: 226,
      lang: 'EN',
      name: 'Guiné Equatorial',
      nationality: 'Guiné Equatorial, Equatoguínica'
    },
    {
      id: 308,
      lang: 'EN',
      name: 'Granada',
      nationality: 'Granadina'
    },
    {
      id: 300,
      lang: 'EL',
      name: 'Grécia',
      nationality: 'Grego, Helênico'
    },
    {
      id: 320,
      lang: 'ES',
      name: 'Guatemala',
      nationality: 'Guatemalteco'
    },
    {
      id: 328,
      lang: 'EN',
      name: 'Guiana',
      nationality: 'Guianense'
    },
    {
      id: 316,
      lang: 'EN',
      name: 'Guam',
      nationality: 'Guamanian, Guambat'
    },
    {
      id: 344,
      lang: 'EN',
      name: 'Hong Kong',
      nationality: 'Hong Kong, Hong Kong'
    },
    {
      id: 340,
      lang: 'ES',
      name: 'Honduras',
      nationality: 'Hondurenha'
    },
    {
      id: 332,
      lang: 'FR',
      name: 'Haiti',
      nationality: 'Haitiano'
    },
    {
      id: 348,
      lang: 'HU',
      name: 'Hungria',
      nationality: 'Húngaro, Magiar'
    },
    {
      id: 360,
      lang: 'IN',
      name: 'Indonésia',
      nationality: 'Indonésio'
    },
    {
      id: 234,
      lang: 'DA',
      name: 'Ilhas Faroe',
      nationality: 'Feroês'
    },
    {
      id: 584,
      lang: 'EN',
      name: 'Ilhas Marshall',
      nationality: 'Marshallese'
    },
    {
      id: 356,
      lang: 'HI',
      name: 'Índia',
      nationality: 'Indiano'
    },
    {
      id: 372,
      lang: 'EN',
      name: 'Irlanda',
      nationality: 'Irlandês'
    },
    {
      id: 368,
      lang: 'AR',
      name: 'Iraque',
      nationality: 'Iraquiano'
    },
    {
      id: 352,
      lang: 'IS',
      name: 'Islândia',
      nationality: 'Islandês'
    },
    {
      id: 376,
      lang: 'IW',
      name: 'Israel',
      nationality: 'Israelense'
    },
    {
      id: 380,
      lang: 'IT',
      name: 'Itália',
      nationality: 'Italiano'
    },
    {
      id: 388,
      lang: 'EN',
      name: 'Jamaica',
      nationality: 'Jamaicano'
    },
    {
      id: 392,
      lang: 'JA',
      name: 'Japão',
      nationality: 'Japonês'
    },
    {
      id: 400,
      lang: 'AR',
      name: 'Jordânia',
      nationality: 'Jordaniano'
    },
    {
      id: 296,
      lang: 'EN',
      name: 'Kiribati',
      nationality: 'I-Kiribati'
    },
    {
      id: 422,
      lang: 'AR',
      name: 'Líbano',
      nationality: 'Libanês'
    },
    {
      id: 430,
      lang: 'EN',
      name: 'Libéria',
      nationality: 'Liberiano'
    },
    {
      id: 662,
      lang: 'EN',
      name: 'Santa Lúcia',
      nationality: 'Santa Lúcia'
    },
    {
      id: 426,
      lang: 'EN',
      name: 'Lesoto',
      nationality: 'Basotho'
    },
    {
      id: 428,
      lang: 'RU',
      name: 'Letônia',
      nationality: 'Letão'
    },
    {
      id: 434,
      lang: 'AR',
      name: 'Líbia',
      nationality: 'Líbio'
    },
    {
      id: 438,
      lang: 'DE',
      name: 'Liechtenstein',
      nationality: 'Liechtenstein'
    },
    {
      id: 440,
      lang: 'RU',
      name: 'Lituânia',
      nationality: 'Lituano'
    },
    {
      id: 442,
      lang: 'FR',
      name: 'Luxemburgo',
      nationality: 'Luxemburgo, Luxemburguês'
    },
    {
      id: 446,
      lang: 'PT',
      name: 'Macau',
      nationality: 'Macaense, Chinês'
    },
    {
      id: 450,
      lang: 'FR',
      name: 'Madagascar',
      nationality: 'Malgaxe'
    },
    {
      id: 458,
      lang: 'MS',
      name: 'Malásia',
      nationality: 'Malaio'
    },
    {
      id: 504,
      lang: 'AR',
      name: 'Marrocos',
      nationality: 'Marroquino'
    },
    {
      id: 508,
      lang: 'PT',
      name: 'Moçambique',
      nationality: 'Moçambicano'
    },
    {
      id: 462,
      lang: 'EN',
      name: 'Maldivas',
      nationality: 'Maldivas'
    },
    {
      id: 484,
      lang: 'ES',
      name: 'México',
      nationality: 'Mexicano'
    },
    {
      id: 496,
      lang: 'MN',
      name: 'Mongólia',
      nationality: 'Mongol'
    },
    {
      id: 466,
      lang: 'FR',
      name: 'Mali',
      nationality: 'Malian, Malinese'
    },
    {
      id: 470,
      lang: 'MT',
      name: 'Malta',
      nationality: 'Maltês'
    },
    {
      id: 492,
      lang: 'FR',
      name: 'Mônaco',
      nationality: 'Monégasque, Monacan'
    },
    {
      id: 474,
      lang: 'FR',
      name: 'Martinica',
      nationality: 'Martiniquais, Martinicano'
    },
    {
      id: 500,
      lang: 'EN',
      name: 'Montserrat',
      nationality: 'Montserratian'
    },
    {
      id: 478,
      lang: 'AR',
      name: 'Mauritânia',
      nationality: 'Mauritano'
    },
    {
      id: 516,
      lang: 'EN',
      name: 'Namíbia',
      nationality: 'Namíbia'
    },
    {
      id: 540,
      lang: 'FR',
      name: 'Nova Caledônia',
      nationality: 'Nova Caledônia'
    },
    {
      id: 566,
      lang: 'EN',
      name: 'Nigéria',
      nationality: 'Nigeriano'
    },
    {
      id: 558,
      lang: 'ES',
      name: 'Nicarágua',
      nationality: 'Nicaragüense'
    },
    {
      id: 562,
      lang: 'FR',
      name: 'Niger',
      nationality: 'Nigerien'
    },
    {
      id: 570,
      lang: 'EN',
      name: 'Niue',
      nationality: 'Niueano'
    },
    {
      id: 578,
      lang: 'NO',
      name: 'Noruega',
      nationality: 'Norueguês'
    },
    {
      id: 524,
      lang: 'NE',
      name: 'Nepal',
      nationality: 'Nepalês, Nepalês'
    },
    {
      id: 520,
      lang: 'EN',
      name: 'Nauru',
      nationality: 'Nauruan'
    },
    {
      id: 554,
      lang: 'EN',
      name: 'Nova Zelândia',
      nationality: 'Nova Zelândia, NZ'
    },
    {
      id: 512,
      lang: 'AR',
      name: 'Oma',
      nationality: 'Omã'
    },
    {
      id: 591,
      lang: 'ES',
      name: 'Panamá',
      nationality: 'Panamenho'
    },
    {
      id: 586,
      lang: 'UR',
      name: 'Paquistão',
      nationality: 'Paquistanês'
    },
    {
      id: 612,
      lang: 'EN',
      name: 'Pitcairn',
      nationality: 'Ilha Pitcairn'
    },
    {
      id: 604,
      lang: 'ES',
      name: 'Peru',
      nationality: 'Peruano'
    },
    {
      id: 258,
      lang: 'FR',
      name: 'Polinésia Francesa',
      nationality: 'Polinésia Francesa'
    },
    {
      id: 585,
      lang: 'EN',
      name: 'Palau',
      nationality: 'Palauan'
    },
    {
      id: 598,
      lang: 'EN',
      name: 'Papua Nova Guiné',
      nationality: 'Papua Nova Guiné, Papua'
    },
    {
      id: 616,
      lang: 'PL',
      name: 'Polônia',
      nationality: 'Polonês'
    },
    {
      id: 620,
      lang: 'PT',
      name: 'Portugal',
      nationality: 'Português'
    },
    {
      id: 600,
      lang: 'ES',
      name: 'Paraguai',
      nationality: 'Paraguaio'
    },
    {
      id: 630,
      lang: 'ES',
      name: 'Porto Rico',
      nationality: 'Porto-riquenho'
    },
    {
      id: 404,
      lang: 'SW',
      name: 'Quênia',
      nationality: 'Queniano'
    },
    {
      id: 638,
      lang: 'FR',
      name: 'Reunião',
      nationality: 'Reunião, Reunião'
    },
    {
      id: 276,
      lang: 'DE',
      name: 'Alemanha',
      nationality: 'Alemão'
    },
    {
      id: 642,
      lang: 'RO',
      name: 'Romênia',
      nationality: 'Romena'
    },
    {
      id: 646,
      lang: 'FR',
      name: 'Ruanda',
      nationality: 'Ruandês'
    },
    {
      id: 686,
      lang: 'FR',
      name: 'Senegal',
      nationality: 'Senegalês'
    },
    {
      id: 674,
      lang: 'IT',
      name: 'San Marino',
      nationality: 'Sammarinese'
    },
    {
      id: 706,
      lang: 'AR',
      name: 'Somália',
      nationality: 'Somali, Somaliano'
    },
    {
      id: 144,
      lang: 'SI',
      name: 'Sri Lanka',
      nationality: 'Sri Lanka'
    },
    {
      id: 694,
      lang: 'EN',
      name: 'Serra Leoa',
      nationality: 'Serra Leoa'
    },
    {
      id: 678,
      lang: 'EN',
      name: 'São Tomé e Príncipe',
      nationality: 'São Tomé'
    },
    {
      id: 748,
      lang: 'EN',
      name: 'Suazilândia',
      nationality: 'Suazi'
    },
    {
      id: 729,
      lang: 'AR',
      name: 'Sudão',
      nationality: 'Sudanês'
    },
    {
      id: 752,
      lang: 'SV',
      name: 'Suécia',
      nationality: 'Sueco'
    },
    {
      id: 756,
      lang: 'FR',
      name: 'Suiça',
      nationality: 'Suíço'
    },
    {
      id: 740,
      lang: 'NL',
      name: 'Suriname',
      nationality: 'Suriname'
    },
    {
      id: 703,
      lang: 'EN',
      name: 'Eslováquia',
      nationality: 'Eslovaco'
    },
    {
      id: 705,
      lang: 'EN',
      name: 'Eslovênia',
      nationality: 'Esloveno, Esloveno'
    },
    {
      id: 690,
      lang: 'EN',
      name: 'Seychelles',
      nationality: 'Seychellois'
    },
    {
      id: 764,
      lang: 'TH',
      name: 'Tailândia',
      nationality: 'Tailandês'
    },
    {
      id: 772,
      lang: 'EN',
      name: 'Tokelau',
      nationality: 'Tokelauan'
    },
    {
      id: 776,
      lang: 'EN',
      name: 'Tonga',
      nationality: 'Tonganês'
    },
    {
      id: 788,
      lang: 'AR',
      name: 'Tunísia',
      nationality: 'Tunisiano'
    },
    {
      id: 798,
      lang: 'EN',
      name: 'Tuvalu',
      nationality: 'Tuvaluano'
    },
    {
      id: 804,
      lang: 'RU',
      name: 'Ucrânia',
      nationality: 'Ucraniano'
    },
    {
      id: 800,
      lang: 'EN',
      name: 'Uganda',
      nationality: 'Uganda'
    },
    {
      id: 858,
      lang: 'ES',
      name: 'Uruguai',
      nationality: 'Uruguaio'
    },
    {
      id: 704,
      lang: 'VI',
      name: 'Vietnã',
      nationality: 'Vietnamita'
    },
    {
      id: 548,
      lang: 'EN',
      name: 'Vanuatu',
      nationality: 'Ni-Vanuatu, Vanuatuan'
    },
    {
      id: 894,
      lang: 'EN',
      name: 'Zâmbia',
      nationality: 'Zâmbia'
    },
    {
      id: 716,
      lang: 'EN',
      name: 'Zimbabue',
      nationality: 'Zimbabuense'
    }
  ]);
}
